// validation/windowValidation.ts

import { formatDate } from "common/service/CommonService";

export function runWindowValidation(sender: any, q: any, options: any): boolean {
  if (q.validationType !== "window") return true;

  if (!q.windowType || !q.windowAmount || !q.windowBaseQuestion) return true;

  const baseVal = sender.getValue(q.windowBaseQuestion);
  const curVal = options.value;

  if (!baseVal || !curVal) return true;

  const baseDate = new Date(baseVal);
  const curDate = new Date(curVal);
  const days = Number(q.windowAmount);

  if (isNaN(baseDate.getTime()) || isNaN(curDate.getTime())) return true;

  let min = new Date(baseDate);
  let max = new Date(baseDate);

  if (q.windowType === "before" || q.windowType === "beforeAfter") {
    min.setDate(min.getDate() - days);
  }

  if (q.windowType === "after" || q.windowType === "beforeAfter") {
    max.setDate(max.getDate() + days);
  }

  if (curDate < min || curDate > max) {
    options.error =
      q.windowError ||
      `Date must be between ${formatDate(String(min))} and ${formatDate(String(max))}`;
    return false;
  }

  return true;
}
